import {addMinutes} from "date-fns";

class CacheItem {
    constructor({data, loadedAt, expirationDate}) {
        this.data = data;
        this.loadedAt = loadedAt;
        this.expirationDate = expirationDate;
    }
}

class IndexedDbHelperClass {
    constructor()  {
        if (window.IndexedDbHelperClass) {
            return window.IndexedDbHelperClass;
        }
        window.IndexedDbHelperClass = this;
    }
    
    isRegistered(){
        return !!this.instance;
    }
    
    registerIndexedDb(appName){
        if(!this.isRegistered()){
            console.log(`Registering IndexedDb with name ${appName}`); 
            this.instance = new IndexedDbClass(appName);            
        }
        else{
            console.log(`IndexedDb with name ${appName} already registered. Skipping.`);
        }
    }
    async listOrCreate(key, delegate, expirationDate) {
        if(!this.isRegistered()){
            console.warn(`Cache miss with key ${key} not registered`);
            return await delegate();
        }
        return await this.instance.listOrCreate(key, delegate, expirationDate);       
    }
	async updateOrReplace(key, data, expirationDate) {
		if (!this.isRegistered()) {
			console.warn(`Updating item - Cache miss with key ${key} not registered`);
			return await this.instance.listOrCreate(key, ()=>data, expirationDate);
		}
		return await this.instance.updateOrReplace(key, data, expirationDate);
	}
    async clear(key) {
        return await this.instance.clear(key);       
    }
}
class IndexedDbClass {
    constructor(appName) {
        this.appName = appName;
        this.storeName = 'cache';
        this.dbPromise = this.#openDb();

        $("document").ready(() => this.#openDb());
    }

    #openDb() {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.appName, 1);
            request.onupgradeneeded = () => {
                const db = request.result;
                if (!db.objectStoreNames.contains(this.storeName)) {
                    db.createObjectStore(this.storeName);
                }
            };
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject(request.error);
        });
    }

    async get(key) {
        const db = await this.dbPromise;
        return new Promise((resolve, reject) => {
            const tx = db.transaction(this.storeName, 'readonly');
            const store = tx.objectStore(this.storeName);
            const req = store.get(key);
            req.onsuccess = () => resolve(req.result);
            req.onerror = () => reject(req.error);
        });
    }

    async #set(key, value) {
        const db = await this.dbPromise;
        return new Promise((resolve, reject) => {
            const tx = db.transaction(this.storeName, 'readwrite');
            const store = tx.objectStore(this.storeName);
            const req = store.put(value, key);
            req.onsuccess = () => resolve();
            req.onerror = () => reject(req.error);
        });
    }

    async listOrCreate(key, delegate, expirationDate) {
        let cached = await this.get(key);
        const now = new Date();
        if (!cached || (cached.expirationDate && new Date(cached.expirationDate) <= now)) {
            console.log(`Cache miss with key ${key}`);
            const data = await delegate();
            
            if(data){
                const item = new CacheItem({
                    data: data,
                    loadedAt: now.toISOString(),
                    expirationDate: expirationDate
                });
                await this.#set(key, item);    
            }
            
            return data;
        }
        console.log(`Cache hit with key ${key}`);
        return cached.data;
    }
	async updateOrReplace(key, delegate, expirationDate) {
		let cached = await this.listOrCreate(key, delegate, expirationDate);
		const now = new Date();
		if(!expirationDate){
			addMinutes(now, 5);
		}
		let delegateData = await delegate();
		let data = {...cached.data, ...delegateData};

		await this.#set(key, new CacheItem({
			data: data,
			loadedAt:  now.toISOString(),
			expirationDate: expirationDate
		}));
		console.log(`Cache with key ${key} updated`);
		return cached.data;
	}

	async clear(key) {
        const db = await this.dbPromise;
        const tx = db.transaction(this.storeName, 'readwrite');
        const store = tx.objectStore(this.storeName);
        store.delete(key);
        return tx.complete;
    }
}

export {CacheItem, IndexedDbClass};
export const IndexedDbHelper = new IndexedDbHelperClass();